<template>
  <Login />
</template>

<script lang="js">
import Login from '@/components/login/index.vue'

export default {
  name: 'LoginPage',
  components: {
    Login,
  }
}
</script>
<style lang="scss">
</style>